import styled from "@emotion/styled";
import { Input } from "@mantine/core";

export const LayoutContainer = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;
  background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  color: ${({ theme }) => theme.colors.settingsColor};
  margin-top: 30px;
  border-radius: 6px;
`;

export const Section = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InputStyledWrapper = styled(Input.Wrapper)`
  display: flex;
  width: 70%;
  justify-content: space-between;
  align-items: center;
`;
